import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const LakeCharles = () => {
  useEffect(() => {
    // Update page title and meta tags
    document.title = 'We Buy Valves Lake Charles | Industrial Equipment Buyers Lake Charles Louisiana';
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Lake Charles Louisiana - Premier valve buyers Lake Charles. We purchase surplus valves, Fisher control valves, and instrumentation from Lake Charles refineries, chemical plants, and LNG terminals. Call 214-854-5638.');
    }
    
    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'we buy valves lake charles, lake charles valve buyers, surplus valves louisiana, fisher control valves, chemical plant equipment, lng equipment buyers');
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/lake-charles');
    
    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves Lake Charles | Industrial Equipment Buyers Lake Charles Louisiana' },
      { property: 'og:description', content: 'We buy valves Lake Charles Louisiana - Premier valve buyers Lake Charles. We purchase surplus valves, Fisher control valves, and instrumentation from refineries, chemical plants, and LNG terminals.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/lake-charles' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Geo tags
    const geoTags = [
      { name: 'geo.position', content: '30.2266;-93.2174' },
      { name: 'geo.placename', content: 'Lake Charles, Louisiana' },
      { name: 'geo.region', content: 'US-LA' }
    ];
    
    geoTags.forEach(tag => {
      let geoTag = document.querySelector(`meta[name="${tag.name}"]`);
      if (!geoTag) {
        geoTag = document.createElement('meta');
        geoTag.setAttribute('name', tag.name);
        document.head.appendChild(geoTag);
      }
      geoTag.setAttribute('content', tag.content);
    });
    
    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/lake-charles",
          "url": "https://valvesalessupply.com/lake-charles",
          "name": "We Buy Valves Lake Charles | Industrial Equipment Buyers Lake Charles Louisiana",
          "description": "We buy valves Lake Charles Louisiana - Premier valve buyers Lake Charles. We purchase surplus valves, Fisher control valves, and instrumentation from Lake Charles refineries, chemical plants, and LNG terminals. Call 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Louisiana",
                "item": "https://valvesalessupply.com/louisiana"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Lake Charles",
                "item": "https://valvesalessupply.com/lake-charles"
              }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - Lake Charles",
          "image": "https://valvesalessupply.com/logo.png",
          "@id": "https://valvesalessupply.com/lake-charles",
          "url": "https://valvesalessupply.com/lake-charles",
          "telephone": "214-854-5638",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Lake Charles",
            "addressRegion": "LA",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 30.2266,
            "longitude": -93.2174
          },
          "areaServed": {
            "@type": "City",
            "name": "Lake Charles",
            "containedIn": {
              "@type": "State",
              "name": "Louisiana"
            }
          },
          "serviceType": ["Industrial Valve Buyers", "Surplus Equipment Buyers", "Chemical Plant Equipment", "LNG Equipment Buyers"]
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const lakeCharlesFacilities = [
    { name: 'Phillips 66 Lake Charles', location: 'Westlake', capacity: '253,000 bpd' },
    { name: 'Citgo Lake Charles', location: 'Lake Charles', capacity: '425,000 bpd' },
    { name: 'Sasol Chemicals', location: 'Westlake', type: 'Chemical Complex' },
    { name: 'Air Liquide', location: 'Westlake', type: 'Gas Plant' },
    { name: 'Cheniere Energy', location: 'Sabine Pass', type: 'LNG Terminal' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Lake Charles refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from all Lake Charles area refineries including Phillips 66, Citgo, and chemical plants. We provide fast quotes and competitive pricing for Southwest Louisiana facilities."
    },
    {
      question: "What types of equipment do you buy from Lake Charles chemical plants?",
      answer: "We buy control valves, safety relief valves, Rosemount transmitters, pH meters, level transmitters, flow meters, analyzers, and specialty chemical processing equipment from Sasol, Air Liquide, and all Lake Charles chemical facilities."
    },
    {
      question: "How quickly can you respond to Lake Charles facilities?",
      answer: "We provide 3-4 hour response times for Lake Charles and Southwest Louisiana facilities. Our Louisiana regional team is experienced with chemical plants, refineries, and LNG terminals in the Calcasieu River industrial complex."
    },
    {
      question: "Do you purchase LNG terminal equipment in Lake Charles?",
      answer: "Yes, we specialize in purchasing cryogenic valves, ball valves, check valves, and LNG-specific equipment from Cheniere Energy and other Lake Charles LNG facilities. We understand the unique requirements of LNG operations."
    },
    {
      question: "What valve brands do you buy from Lake Charles facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Velan, Kitz, Rosemount, Emerson, Honeywell, and Endress+Hauser equipment from Lake Charles refineries, chemical plants, and LNG terminals."
    },
    {
      question: "Do you buy equipment during Lake Charles plant turnarounds?",
      answer: "Yes, we provide emergency turnaround support for Lake Charles facilities. We can quickly evaluate and purchase surplus equipment during planned shutdowns and maintenance turnarounds at Phillips 66, Citgo, and chemical plants."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/142d7b93171743ac92ffe21b1832fff7.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Lake Charles Louisiana</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Premier <strong>valve buyers Lake Charles</strong> - We purchase surplus valves, Fisher control valves, 
              and instrumentation from Lake Charles refineries, chemical plants, and LNG terminals. 
              Fast response and competitive pricing for all Southwest Louisiana facilities.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET LAKE CHARLES QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Lake Charles Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">LAKE CHARLES VALVE BUYERS - INDUSTRIAL HUB</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Lake Charles is Louisiana's major petrochemical hub along the Calcasieu River. As experienced 
                <strong className="text-[#1B3A5F]"> Lake Charles valve buyers</strong> and 
                <strong className="text-[#1B3A5F]"> chemical plant equipment buyers</strong>, we understand 
                the unique needs of this diverse industrial complex.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We buy <strong className="text-[#1B3A5F]">surplus control valves Lake Charles</strong>, 
                Rosemount transmitters, safety relief valves, and specialty chemical processing equipment 
                from Phillips 66, Citgo, Sasol, and all Lake Charles area facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">700K+</div>
                  <div className="text-gray-600">BPD Capacity</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">3-4 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">20+</div>
                  <div className="text-gray-600">Major Facilities</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">LAKE CHARLES FACILITIES</h3>
              <div className="space-y-4">
                {lakeCharlesFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">{facility.capacity || facility.type}</div>
                      <div className="text-gray-600 text-sm">{facility.capacity ? 'Capacity' : 'Type'}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES LAKE CHARLES - TOP PRICES</h2>
            <p className="text-gray-600 text-xl">Professional equipment buyers serving Southwest Louisiana</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                category: 'Refinery Valves',
                brands: ['Fisher', 'Masoneilan', 'Flowserve', 'Cameron'],
                types: ['Control Valves', 'Gate Valves', 'Globe Valves', 'Ball Valves']
              },
              {
                category: 'Chemical Processing',
                brands: ['Rosemount', 'Emerson', 'Honeywell', 'Endress+Hauser'],
                types: ['pH Meters', 'Level Transmitters', 'Flow Meters', 'Analyzers']
              },
              {
                category: 'LNG Equipment',
                brands: ['Velan', 'Kitz', 'Bonney Forge', 'Powell'],
                types: ['Cryogenic Valves', 'Ball Valves', 'Check Valves', 'Relief Valves']
              }
            ].map((equipment, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">{equipment.category}</h3>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands We Buy:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 className="text-gray-800 font-bold mb-3">Equipment Types:</h4>
                  <div className="space-y-2">
                    {equipment.types.map((type, typeIndex) => (
                      <div key={typeIndex} className="flex items-center">
                        <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                        <span className="text-gray-600">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Coverage in Lake Charles
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide equipment pickup services throughout the greater Lake Charles metropolitan area
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Industrial Lake Charles</h3>
              <p className="text-gray-600">Westlake, Sulphur, Carlyss areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">East Lake Charles</h3>
              <p className="text-gray-600">Iowa, Jennings, Welsh areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">North Lake Charles</h3>
              <p className="text-gray-600">DeQuincy, Ragley, Reeves areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Buy in Lake Charles
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality petrochemical and LNG equipment from leading manufacturers in Lake Charles, Louisiana
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">LNG Valves Lake Charles</h3>
              <p className="text-gray-600 mb-4">
                Fisher Control Valves Lake Charles, Masoneilan Lake Charles, Q-Check Lake Charles, Valtek Lake Charles
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Fisher LC</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Masoneilan LC</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Q-Check LC</span>
              </div>
              <a href="/contact" className="text-teal-600 hover:text-teal-700 font-medium">Get LC Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-lg border border-orange-100">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrumentation LC</h3>
              <p className="text-gray-600 mb-4">
                Rosemount Transmitters Lake Charles, Foxboro Lake Charles, Fisher Instruments LC, Barton Lake Charles
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Rosemount LC</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Foxboro LC</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Fisher LC</span>
              </div>
              <a href="/contact" className="text-orange-600 hover:text-orange-700 font-medium">Get LC Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-water-percent-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Flow Equipment LC</h3>
              <p className="text-gray-600 mb-4">
                Badger Meters Lake Charles, Neptune Lake Charles, Rockwell Lake Charles, chemical flow measurement
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Badger LC</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Neptune LC</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Rockwell LC</span>
              </div>
              <a href="/contact" className="text-green-600 hover:text-green-700 font-medium">Get LC Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-lg border border-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Actuators Lake Charles</h3>
              <p className="text-gray-600 mb-4">
                Limitorque Lake Charles, Bettis Actuators Lake Charles, Fisher Actuators LC, Q-Check Actuators LC
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Limitorque LC</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Bettis LC</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Fisher LC</span>
              </div>
              <a href="/contact" className="text-purple-600 hover:text-purple-700 font-medium">Get LC Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-lg border border-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Fittings Lake Charles</h3>
              <p className="text-gray-600 mb-4">
                Swagelok Lake Charles, Parker Fittings Lake Charles, Anderson Greenwood LC, Hoke Lake Charles
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Swagelok LC</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Parker LC</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Anderson LC</span>
              </div>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">Get LC Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-6 rounded-lg border border-amber-100">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-temp-hot-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Temperature Lake Charles</h3>
              <p className="text-gray-600 mb-4">
                WIKA Gauges Lake Charles, All Temp Sensors LC, OCI Lake Charles, McDaniel Lake Charles
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">WIKA LC</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">All Temp LC</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">OCI LC</span>
              </div>
              <a href="/contact" className="text-amber-600 hover:text-amber-700 font-medium">Get LC Quote →</a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Sell Your Equipment in Lake Charles?</h3>
              <p className="text-lg text-gray-600 mb-6">
                Contact us today for a free quote on your surplus petrochemical and LNG equipment in Lake Charles, Louisiana
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:2148545638" className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition duration-300">
                  Call (214) 854-5638
                </a>
                <a href="/contact" className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition duration-300">
                  Get Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">LAKE CHARLES VALVE BUYERS</h2>
            <p className="text-gray-200 text-xl">Professional service for all Louisiana facilities</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">LAKE CHARLES OFFICE</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">214-854-5638</div>
                    <div className="text-gray-600">Louisiana Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">lakecharles@valvesalessupply.com</div>
                    <div className="text-gray-600">Equipment Evaluations</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">3-4 Hour Response</div>
                    <div className="text-gray-600">Southwest Louisiana</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Louisiana Regional Manager</h4>
                <p className="text-gray-600">Mark Driver - Chemical & LNG specialist</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">LAKE CHARLES ADVANTAGES</h3>
              <div className="space-y-4">
                {[
                  'Top prices for chemical plant equipment',
                  'Fastest response in Southwest Louisiana',
                  'Expert Lake Charles facility knowledge',
                  'Complete environmental compliance',
                  'Local team with LNG experience',
                  'Emergency turnaround support'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <a
                  href="tel:214-854-5638"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  CALL: 214-854-5638
                  <i className="ri-phone-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">LAKE CHARLES VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LakeCharles;
